import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SculptureForm } from '../_models/sculptureform';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class SculptureFormService {
    //baseUrl: string = "https://localhost:44399/api/sculptureform/";
    // baseUrl: string = "https://api-heykel.milliyetsanat.com/api/sculptureform/";
    // headers: string =  { 'Authorization': 'Bearer my-token', 'My-Custom-Header': 'foobar' };
    sayi: number;
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json;charset=UTF-8' }),
        observe: 'response' as 'response'
    };

    //baseUrl: string = "https://localhost:44399/api/sculptureform/";
    baseUrl: string = "https://api-heykel.milliyetsanat.com/api/sculptureform/";
    constructor(private http: HttpClient) {

    }

    getSculptureForms(): Observable<SculptureForm[]> {
        return this.http.get<SculptureForm[]>(this.baseUrl);
    }

    getSculptureForm(id: number): Observable<SculptureForm> {
        return this.http.get<SculptureForm>(this.baseUrl + id);
    }

    applyNewSculptureForm(model: any) {
        return this.http.post(this.baseUrl + 'apply', model, this.httpOptions);
    }

}



